import { useEffect, useState } from "react";
import { fetchMovieTrailer } from "../api/tmdb";

function TrailerModal({ movieId, title, onClose }) {
  const [trailer, setTrailer] = useState(null);

  useEffect(() => {
    fetchMovieTrailer(movieId).then(setTrailer);
  }, [movieId]);

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>✖</button>

        <h2>{title}</h2>

        {trailer ? (
          <iframe
            width="100%"
            height="315"
            src={`https://www.youtube.com/embed/${trailer.key}`}
            title="Movie Trailer"
            frameBorder="0"
            allowFullScreen
          />
        ) : (
          <p>Trailer not available.</p>
        )}
      </div>
    </div>
  );
}

export default TrailerModal;

